import cardBag from '../assets/card_bag.png';
import bolt from '../assets/bolt.svg';
import Copy from './Copy';
import Cta, { ctaProps } from './Cta';
import { GlowSm, Bolt, Coin } from './Decor';

const inr = (n) => '₹' + (n >= 1000 ? Math.round(n / 1000) + 'K' : n);

/* "Spend with your GoSats Card" — progress towards the bonus track. `data` is
   the API `cardSpend` section: { text, highlight, spent, bonusThreshold,
   trackMax, claimEnabled, cta }.
   When `claimEnabled` and `cta.enabled` are both true, the CTA claims the ₹10k
   reward (via `onClaim`) instead of dispatching a native action. */
export default function CardSpendSection({ data, onAction, onClaim, claiming = false, claimed = false, claimDisabled = false }) {
  const spent = data.spent || 0;
  const trackMax = data.trackMax || 1;
  const pct = Math.min(100, Math.max(0, (spent / trackMax) * 100));

  const isClaim = data.claimEnabled === true && data.cta && data.cta.enabled === true;
  const ctaConf = isClaim
    ? {
        label: claimed ? 'CLAIMED' : (data.cta.text || 'Claim'),
        disabled: claiming || claimed || claimDisabled, // disabled after a failed claim too
        loading: claiming,   // shimmer, no label/arrow while the claim is in flight
        hideArrow: claimed,  // claimed state shows just "CLAIMED"
        onClick: onClaim,
      }
    : ctaProps(data.cta, onAction);

  return (
    <section className="bbd-spend">
      <GlowSm />
      <div className="bbd-spend-art">
        <img src={cardBag} alt="" />
      </div>
      <div className="bbd-spend-decor">
        <Bolt className="" src={bolt} />
        <Coin className="" />
      </div>

      <p className="bbd-copy bbd-spend-copy"><Copy text={data.text} highlight={data.highlight} /></p>

      <div className="bbd-progress" role="progressbar" aria-valuemin={0} aria-valuemax={trackMax} aria-valuenow={Math.min(spent, trackMax)}>
        <div className="bbd-progress-fill" style={{ width: pct + '%' }} />
      </div>
      <div className="bbd-progress-labels">
        <span>₹0</span>
        <span>{inr(trackMax)}</span>
      </div>

      <Cta {...ctaConf} />
    </section>
  );
}
